'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasVisitorEmail = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEmailCaptureStatus = (0, _get2.default)('emailCapture');

var getHasVisitorEmail = exports.getHasVisitorEmail = (0, _reselect.createSelector)(getEmailCaptureStatus, (0, _get2.default)('hasVisitorEmail'));


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getHasVisitorEmail.js
// module id = 383
// module chunks = 2 3